import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getResetRequestAuthPath = () => urlHelper('/auth/reset-request');
